import { Lock } from '@fos/ui';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { btnClass, Button, Card } from '@fos/ui';

/** Error pages (board Errori): 404, link no longer valid, server error with the request reference. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="public-page">
      <Card className="pad stack" style={{ gap: 12 }}>
        <div className="label">{t('errors_page.404_label')}</div>
        <h1 style={{ fontSize: 22 }}>{t('errors_page.404_title')}</h1>
        <p className="text-2">{t('errors_page.404_text')}</p>
        <div className="row-flex">
          <Link to="/app/today" className={btnClass('dark')}>
            {t('errors_page.go_today')}
          </Link>
          <Link to="/app/search" search={{ q: '' }} className={btnClass()}>
            {t('errors_page.search')}
          </Link>
        </div>
      </Card>
    </main>
  );
}

export function LinkUnavailable({ contact }: { contact?: string | null }) {
  const { t } = useTranslation();
  return (
    <Card className="pad stack" style={{ gap: 12 }}>
      <span className="status-icon" aria-hidden="true">
        <Lock size={22} />
      </span>
      <h1 className="public-title">{t('errors_page.link_title')}</h1>
      <p className="text-2">{t('errors_page.link_text')}</p>
      <p className="text-2">{t('errors_page.link_text2')}</p>
      {contact && (
        <div>
          <a className={btnClass()} href={`mailto:${contact}`}>
            {contact}
          </a>
        </div>
      )}
    </Card>
  );
}

export function ServerErrorPage({ error }: { error: unknown }) {
  const { t } = useTranslation();
  const ref = (error as { details?: { request_id?: string }; requestId?: string } | null)?.requestId ?? null;
  return (
    <main className="public-page">
      <Card className="pad stack" style={{ gap: 12 }}>
        <div className="label">{t('errors_page.server_label')}</div>
        <h1 style={{ fontSize: 22 }}>{t('errors_page.server_title')}</h1>
        <p className="text-2">{t('errors_page.server_text')}</p>
        <div className="row-flex">
          <Button variant="dark" onClick={() => window.location.reload()}>
            {t('errors_page.retry')}
          </Button>
          {ref && <span className="chip">{t('errors_page.reference', { id: ref })}</span>}
        </div>
      </Card>
    </main>
  );
}
